<div class="container paginado text-center mb-5">
    <button class="btn btn-primary" *ngFor="let item of arrayPaginas" (click)="cambiarPagina(item-1)">{{item}}</button>    
</div>

  